import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=0545a9be&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0545a9be')) {
      api.createRecord('0545a9be', component.options)
    } else {
      api.reload('0545a9be', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=0545a9be&", function () {
      api.rerender('0545a9be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PyppVq2E3p5j/JS/offershelp.vue"
export default component.exports